const clientId = '7d1b2b69737b4d2fa67b31581466d076';
const redirectUri = 'https://music-muse.netlify.app/';
let accessToken;

const Spotify = {
  getAccessToken(scope = 'user-read-recently-played') {
    if(accessToken) {
      return accessToken;
    }

    // Check for an access token match
    const accessTokenMatch = window.location.href.match(/access_token=([^&]*)/);
    const expiresInMatch = window.location.href.match(/expires_in=([^&]*)/)

    if(accessTokenMatch && expiresInMatch) {
      // Set the access token value
      accessToken = accessTokenMatch[1];
      // Set a variable for the expiration time
      const expiresIn = Number(expiresInMatch[1]);
      // Set the access token to expire at the value for expiration time
      window.setTimeout(() => accessToken = '', expiresIn * 1000);
      // Clear the parameters from the URL, so the app doesnt try grabbing the access token after it has expired
      window.history.pushState('Access Token', null, '/');

      return accessToken
    } else {
      const accessUrl = `https://accounts.spotify.com/authorize?client_id=${clientId}&response_type=token&scope=${scope}&redirect_uri=${redirectUri}`;
      window.location.href = accessUrl;
    }

  },

  search(term) {
    const scope = 'playlist-modify-public';
    // Getting this creates a temporary lag where user needs to submit request twice...
    const accessToken = Spotify.getAccessToken(scope);
    return fetch(`https://api.spotify.com/v1/search?type=track&q=${term}`, {
      headers: { 
        Authorization: `Bearer ${accessToken}`
      } 
    }).then(response => {
      if(response.ok) {
      return response.json();
      }
      throw new Error('Request failed!');
    }, networkError => console.log(networkError.message)
    ).then(jsonResponse => {
      if(!jsonResponse.tracks) {
        return [];
      }
      return jsonResponse.tracks.items.map(track => ({
        id: track.id,
        name: track.name,
        artist: track.artists[0].name,
        album: track.album.name,
        sample: track.preview_url,
        uri: track.uri,
        location: 'search-results'
      }));
    })
  },

  savePlaylist(name, trackUris) {
    if(!name || !trackUris.length) {
      return;
    }

    const accessToken = Spotify.getAccessToken();
    const headers = { Authorization: `Bearer ${accessToken}` }
    let userId;

    return fetch('https://api.spotify.com/v1/me', { headers: headers }
    ).then(response => {
      if(response.ok) {
        return response.json();
      }
      throw new Error('Request failed!');
    }, networkError => console.log(networkError.message)
    ).then(jsonReponse => {
      userId = jsonReponse.id;
      return fetch(`https://api.spotify.com/v1/users/${userId}/playlists`, {
        headers: headers,
        method: 'POST',
        body: JSON.stringify({ name: name })
      }).then(response => {
        if(response.ok) {
          return response.json();
        }
        throw new Error('Request failed!');
      }, networkError => console.log(networkError.message)
      ).then(jsonReponse => {
        const playlistId = jsonReponse.id;
        return fetch(`https://api.spotify.com/v1/users/${userId}/playlists/${playlistId}/tracks`, {
          headers: headers,
          method: 'POST',
          body: JSON.stringify({ uris: trackUris })
        });
      })
    })
  },

  // Not production ready. Feature is intended to bring in the users recently played song to set state on recently played.
  getRecentlyPlayed() {
    const scope = 'user-read-recently-played'
    const accessToken = Spotify.getAccessToken(scope);
    const headers = { Authorization: `Bearer ${accessToken}` }

    return fetch(`https://api.spotify.com/v1/me/player/recently-played`, {
      headers: headers
    }).then(response => {
      return response.json();
    }).then(jsonReponse => {
      return jsonReponse.items.map(track => ({
        id: track.track.id,
        name: track.track.name,
        album: track.track.album.name,
        artist: track.track.artists[0].name,
        sample: track.track.preview_url,
        uri: track.track.uri,
        location: 'recently-played'
      })
      );
    })
  }
}

export default Spotify;